import React, { useState } from "react";
import { Col, Row, Card, Input, Select, Space, message } from "antd";
import axios from "axios";
import DATA_TYPE_OPTIONS from "./data/dataTypeOptions";
import CheckContnoHistory, { groupByRound } from "./preview/CheckContnoHistory";
import { api_inv_check_contno, HEADERS_BASIC90 } from "./api/apiCent90";
import ModalConfirmLetter from "./modal_all/ModalConfirmLetter";
import ModalEMSLetter from "./modal_all/ModalEMSLetter";

/**
 * OffRoundLetterContent
 * เนื้อหาของ tab "ออกจดหมายนอกรอบ"
 *  - ค้นหาสัญญา  : check-contno -> ประวัติจดหมายบอกเลิกของสัญญา (workCancelContract) แสดงแบบ Collapse ทีละรอบ
 *  - ยืนยันข้อมูล : เปิด Modal โหลดข้อมูลสดจาก DB2 (search-cc-manual) แล้วบันทึก (create-cc-manual)
 *  - พิมพ์จดหมาย : ปุ่มท้ายแถวแต่ละรอบ -> load-cc-h ของรอบนั้น พิมพ์จดหมาย + ยิง EMS
 */
function OffRoundLetterContent() {
  const [dataType, setDataType] = useState("rpsl");
  const [contno, setContno] = useState("");
  const [searchedDataType, setSearchedDataType] = useState(null); // dataType ที่ใช้ค้นหาล่าสุด (กันเปลี่ยน Select หลังค้นหา)
  const [dataCheck, setDataCheck] = useState([]); // ประวัติจาก check-contno (ตาราง)
  const [searchedContno, setSearchedContno] = useState(""); // เลขสัญญาที่ค้นหาล่าสุด
  const [loading, setLoading] = useState(false);

  // ประวัติจดหมายบอกเลิกของสัญญา
  const loadCheckContno = async (value) => {
    const res = await axios.get(
      `${api_inv_check_contno}${encodeURIComponent(value)}`,
      { headers: HEADERS_BASIC90 },
    );
    console.log("check-contno", res.data);
    return res.data?.workCancelContract || [];
  };

  const handleSearch = async () => {
    const value = contno.trim();
    if (!value) return;
    try {
      setLoading(true);
      setDataCheck(await loadCheckContno(value));
      setSearchedContno(value);
      setSearchedDataType(dataType);
    } catch (err) {
      console.log(err);
      setDataCheck([]);
      setSearchedContno("");
      setSearchedDataType(null);
      message.error("ค้นหาสัญญาไม่สำเร็จ");
    } finally {
      setLoading(false);
    }
  };

  // บันทึกสำเร็จแล้วโหลดประวัติใหม่ให้เห็นรายการที่เพิ่งเพิ่ม
  // เรียกหลังบันทึกข้อมูล (create-cc-manual) และหลังบันทึก EMS (update-parcelno-cc-h)
  const handleSaved = async () => {
    if (!searchedContno) return;
    try {
      setDataCheck(await loadCheckContno(searchedContno));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Row style={{ width: "90%", marginLeft: "5%" }}>
      <Col md={24} xs={24} style={{ textAlign: "center", marginTop: "40px" }}>
        {/* ค้นหา + ปุ่มยืนยัน + ปุ่มพิมพ์ อยู่แถวเดียวกัน (มือถือ wrap ลงแถวล่าง) */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <Space.Compact style={{ flex: "1 1 400px", maxWidth: 600 }}>
            <Select
              size="large"
              value={dataType}
              onChange={setDataType}
              options={DATA_TYPE_OPTIONS}
              style={{ width: 130 }}
            />
            <Input.Search
              placeholder="ค้นหาด้วยเลขสัญญา"
              allowClear
              enterButton="ค้นหาสัญญา"
              size="large"
              // main.css บังคับ .ant-input { height: 40px } ทำให้ input ข้างใน (allowClear) ล้นกรอบ
              styles={{ input: { height: "auto" } }}
              value={contno}
              onChange={(e) => setContno(e.target.value)}
              onSearch={handleSearch}
              loading={loading}
            />
          </Space.Compact>
          <ModalConfirmLetter
            contno={searchedContno}
            contractSchema={searchedDataType}
            onSaved={handleSaved}
          />
        </div>
      </Col>
      <Col
        md={24}
        xs={24}
        style={{ textAlign: "center", marginTop: "20px", padding: 0 }}
      >
        <Card
          title={
            searchedContno ? (
              <span style={{ fontWeight: 400, color: "#8c8c8c" }}>
                ประวัติจดหมายบอกเลิก สัญญา {searchedContno} (
                {groupByRound(dataCheck).length} รายการ)
              </span>
            ) : null
          }
        >
          {searchedContno ? (
            <CheckContnoHistory
              data={dataCheck}
              renderExtra={(group) => (
                <ModalEMSLetter
                  size="small"
                  contno={searchedContno}
                  contractSchema={group.items[0]?.contractSchema}
                  roundDate={group.roundDate}
                  onSaved={handleSaved}
                />
              )}
            />
          ) : null}
        </Card>
      </Col>
    </Row>
  );
}

export default OffRoundLetterContent;
